<template>
	<CreationWizardStepWrapper>
		<template #header>
			<ChooseInstallableForAddOnHeader v-bind="$props" v-on="$listeners" />
		</template>
		<ChooseInstallableForFeature :featureType="featureType" :installables="installablesOptions" @choose="chooseInstallable" />
	</CreationWizardStepWrapper>
</template>

<script>
import ChooseInstallableForAddOnHeader from './ChooseInstallableForAddOnHeader.vue';
import props from './ChooseInstallableForAddOn.props';
import { FeatureType } from '../ChooseProjectAndFeatureType/FeatureTypeSelector/feature-type-selector.const';
import ChooseInstallableMixin from '../common/ChooseInstallableMixin';
export default {
	name: 'ChooseInstallableForAddOn',
	mixins: [/*WizardStepMixin, - comes from ChooseInstallableMixin */ ChooseInstallableMixin],
	props,
	components: { ChooseInstallableForAddOnHeader },
	computed: {
		installablesOptions() {
			return []; // [{ id: 'sadsad', title: 'ins' }];
		},
		featureType() {
			return FeatureType.AddOn;
		},
	},
};
</script>

<style lang="scss" scoped></style>
